import { IPriceRelevance } from '../../types/newbuilding/priceRelevance';
import { IApplicationState } from '../../types/redux';

export function getPriceRelevance(state: IApplicationState): IPriceRelevance | null {
  return state.newbuilding.priceRelevance;
}
